export const getFullAccountingPeriodsSection = (excelData) => {
  return [
    excelData.apCompNames,
    excelData.apStartDates,
    excelData.apEndDates,
    [],
    excelData.apCurrency,
    excelData.apFx,
    [],
    ["Net tax-interest expense/(income) section"],
    [],
    ["Non-trading loan relationships"],
    excelData.APnltr_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.APnltr_exclude_exchange_gains_losses,
    excelData.APnltr_exclude_impairment_gains_losses,
    excelData.APnltr_exclude_tax_interest_income_double_relief,
    excelData.APnltr_adjustment_amortised_cost_basis,
    excelData.APnltr_adjustment_qualifying_election,
    excelData.APnltr_exclude_defined_benefit_pension,
    excelData.APnltr_bank_expenses,
    excelData.APnltr_adjustment_gaap_transition,
    excelData.APnltr_adjustment_lease_finance_cost,
    excelData.APnltr_other_adjustments_1,
    excelData.APnltr_other_adjustments_2,
    excelData.APnltr_other_adjustments_3,
    excelData.APntlr_subtotal,
    [],
    ["Non-trading derivative contracts"],
    excelData.APntdc_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.APntdc_exclude_exchange_gains_losses,
    excelData.APntdc_exclude_impairment_gains_losses,
    excelData.APntdc_exclude_tax_interest_income_double_relief,
    excelData.APntdc_exclude_ordinary_trade,
    excelData.APntdc_exclude_derivatives_without_subject_matters_384387 ||
      excelData[
        "APntdc_exclude_derivatives_without_subject_matters_384(4)_s387(4)"
      ],
    excelData.APntdc_adjustment_qualifying_election,
    excelData.APntdc_adjustment_gaap_transition,
    excelData.APntdc_adjustment_disregard_regulations,
    excelData.APntdc_other_adjustments_1,
    excelData.APntdc_other_adjustments_2,
    excelData.APntdc_other_adjustments_3,
    excelData.APntdc_subtotal,
    [],
    ["Trading loan relationships"],
    excelData.APtlr_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.APtlr_exclude_exchange_gains_losses,
    excelData.APtlr_exclude_impairment_gains_losses,
    excelData.APtlr_exclude_tax_interest_income_double_relief,
    excelData.APtlr_adjustment_amortised_cost_basis,
    excelData.APtlr_adjustment_qualifying_election,
    excelData.APtlr_exclude_defined_benefit_pension,
    excelData.APtlr_bank_expenses,
    excelData.APtlr_adjustment_gaap_transition,
    excelData.APtlr_adjustment_lease_finance_cost,
    excelData.APtlr_other_adjustments_1,
    excelData.APtlr_other_adjustments_2,
    excelData.APtlr_other_adjustments_3,
    excelData.APtlr_subtotal,
    [],
    ["Trading derivative contracts"],
    excelData.APtdc_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.APtdc_exclude_exchange_gains_losses,
    excelData.APtdc_exclude_impairment_gains_losses,
    excelData.APtdc_exclude_tax_interest_income_double_relief,
    excelData.APtdc_exclude_ordinary_trade,
    excelData.APtdc_exclude_derivatives_without_subject_matters_384387,
    excelData.APtdc_adjustment_qualifying_election,
    excelData.APtdc_adjustment_gaap_transition,
    excelData.APtdc_adjustment_disregard_regulations,
    excelData.APtdc_other_adjustments_1,
    excelData.APtdc_other_adjustments_2,
    excelData.APtdc_other_adjustments_3,
    excelData.APtdc_subtotal,
    [],
    ["Other financing arrangements"],
    excelData.APofa_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.APofa_exclude_tax_interest_income_double_relief,
    excelData.APofa_adjustment_qualifying_election,
    excelData.APofa_adjustment_gaap_transition,
    excelData.APofa_adjustment_finance_lease,
    excelData.APofa_adjustment_debt_factoring,
    excelData.APofa_adjustment_service_concession,
    excelData.APofa_other_adjustments_1,
    excelData.APofa_other_adjustments_2,
    excelData.APofa_other_adjustments_3,
    excelData.APofa_subtotal,
    [],
    excelData.APnet_tax_interest_totals,
    excelData.tax_interest_total_for_period_gbp,
    [],
    [],
    ["Tax-EBITDA section"],
    excelData.APcte_condition_a,
    excelData.APcte_condition_b,
    excelData.APcte_restrictions_reactivations_included,
    excelData.APtebitda_adjustments,
    excelData.APcte_subtotal,
    [],
    ["Adjustments - s407 TIOPA 2010"],
    excelData.APnet_tax_interest_totals,
    excelData.APs407_tiopa_capital_allowance_charges,
    excelData.APs407_tiopa_relevant_intangible_debits_credits,
    excelData.APs407_tiopa_adjustment_intangible_debit_credits,
    excelData.APs407_tiopa_other_period_losses,
    excelData.APs407_tiopa_loan_relationship_deficts_other_periods,
    excelData.APs407_tiopa_expenses_management_other_periods,
    excelData.APs407_tiopa_group_relief,
    excelData.APs407_relief_rd_expenditure_credit,
    excelData.APs407_relief_rd_additional_relief,
    excelData.APs407_relief_trading_loss,
    excelData.APs407_relief_contaminated_land_relief,
    excelData.APs407_relief_creative_industries,
    excelData.APs407_relief_charitable_donation,
    excelData.APs407_relief_patent_box_profits,
    excelData.APs407_relief_dtr_adjustment_tax_rate_equal_uk,
    excelData.APs407_relief_adjustment_qualifying_infrastructure,
    excelData.APs407_relief_adjustment_gaap_items,
    excelData.APs407_relief_finance_lease_depreciation,
    excelData.APs407_relief_reversal_of_lease_depreciation,
    excelData.APs407_relief_long_funding_lease_deduction,
    excelData.APs407_relief_finance_lease_rentals_receivable,
    excelData.APs407_relief_long_funding_lessee,
    excelData.APs407_relief_adjustment_misc_losses,
    excelData.APs407_relief_group_relief,
    excelData.APs407_relief_adjustment_disregarded_regulations,
    excelData.APs407_relief_other_adjustments_1,
    excelData.APs407_relief_other_adjustments_2,
    excelData.APs407_relief_other_adjustments_3,
    excelData.APtax_ebitda,
    excelData.tax_ebitda_total_for_period_gbp,
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    /* ["CIR specific attributes"],
        excelData.non_consenting_company,
        excelData.trade_small_or_negligible,
        excelData.trade_uncommercial_or_non_statutory,
        excelData.investment_business_ceased,
        excelData.cta10_change_in_ownership_rules,
        [],
        ["Company Type"],
        excelData.type_reit_company,
        excelData.type_ring_fence_company,
        excelData.type_investment_manager,
        excelData.type_insurance_company,
        excelData.type_shipping_company,
        excelData.type_cooperative_company,
        excelData.type_charity_company,
        excelData.type_banking_company,*/
  ];
};
